import { render, staticRenderFns } from "./OutstandingPaymentRecord.vue?vue&type=template&id=3512075a&scoped=true&"
import script from "./OutstandingPaymentRecord.vue?vue&type=script&lang=js&"
export * from "./OutstandingPaymentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3512075a",
  null
  
)

export default component.exports